module.exports = __webpack_public_path__ + "static/img/game.553a3fa8.svg";